<template>
  <div>
    <div class="gap">
      <div class="title title-mb">
        <div class="title-block">
          <div class="block"></div>
          <div class="titleText">基本信息</div>
        </div>
        <div>
          <span>运输单号：</span>
          <span>{{ formData.bizNo }}</span>
        </div>
      </div>
      <el-form :model="formData" ref="form" label-suffix="：" label-position="left">
        <el-row :gutter="20">
          <el-col :span="12" :xs="12">
            <el-form-item label="车牌号"> {{ formData.licensePlateNumber || '-' }} </el-form-item>
          </el-col>
          <el-col :span="12" :xs="12">
            <el-form-item label="运输时间">
              {{ formData.traceabilityNodeTime ? parseTime(formData.traceabilityNodeTime, '{y}-{m}-{d} {h}:{i}') : '-' }}
            </el-form-item>
          </el-col>
          <el-col :span="12" :xs="12">
            <el-form-item label="锁号"> {{ formData.lockNumber || '-' }} </el-form-item>
          </el-col>
          <el-col :span="12" :xs="12">
            <el-form-item label="运输总费用（元）"> {{ ThousandAndDecimal(formData.freightAmount || '-') }} </el-form-item>
          </el-col>
          <el-col :span="12" :xs="12">
            <el-form-item label="司机"> {{ formData.driverName || '-' }} </el-form-item>
          </el-col>

          <el-col :span="12" :xs="12">
            <el-form-item label="联系方式"> {{ formData.driverContacts || '-' }} </el-form-item>
          </el-col>
          <el-col :span="24" :xs="12">
            <el-form-item label="备注"> {{ formData.remark || '-' }} </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <div class="gap">
      <div class="title title-mb">
        <div class="title-block">
          <div class="block"></div>
          <div class="titleText">采摘批次信息</div>
        </div>
      </div>

      <TablePublic :colLists="pickColLists" :tableData="formData.itemList" :paginationFlag="false"> </TablePublic>
    </div>

    <div class="gap">
      <div class="title title-mb">
        <div class="title-block">
          <div class="block"></div>
          <div class="titleText">照片视频</div>
        </div>
      </div>

      <div class="file" @click="lookFile">
        <img class="file-icon" src="https://peelprod.oss-cn-shenzhen.aliyuncs.com/biz/173026022759281382.png" />
        <div class="file-name">照片视频</div>
      </div>
    </div>

    <div class="gap">
      <div class="title title-mb">
        <div class="title-block">
          <div class="block"></div>
          <div class="titleText">历史修改记录</div>
        </div>
      </div>

      <TablePublic :colLists="historyColLists" :tableData="tableData" :paginationFlag="false">
        <template slot="modificationDesc" slot-scope="scope">
          <div style="white-space: normal;text-align: left;">{{ scope.data.modificationDesc }}</div>
          <div slot="reference" @click="handleHistoryDetail(scope.data)" style="width: 150px">
            <span>“鲜果信息"修改</span>
            <span class="view_button"><详情></span>
          </div>
        </template>
        <template slot="reason" slot-scope="scope">
          <div style="white-space: normal;">{{ scope.data.reason }}</div>
        </template>
      </TablePublic>
    </div>

    <div class="gap">
      <div class="hbwtween" style="width: 70%; font-size: 14px">
        <div>操作人：{{ formData.createBy }}</div>
        <div>操作时间：{{ parseTime(formData.createTime, '{y}-{m}-{d} {h}:{i}') }}</div>
      </div>
    </div>

    <Mdialog
      title="查看照片视频"
      :visible.sync="fileDialog"
      width="60%"
      :close-on-click-modal="false"
      :append-to-body="true"
      :destroy-on-close="true"
      @closes="fileDialog = false"
    >
      <Photo :imgArr="imgArr" :videoArr="videoArr" />
    </Mdialog>

    <Mdialog
      title="鲜果信息修改详情"
      :visible.sync="freshModifcationDialog"
      width="50%"
      :close-on-click-modal="false"
      :append-to-body="true"
      :destroy-on-close="true"
      @closes="freshModifcationDialog = false"
    >
      <ModifcationDetail :currContent="historyForm.currContent" :orignalContent="historyForm.orignalContent" />
    </Mdialog>
  </div>
</template>

<script>
import Mdialog from '@/components/Mdialog'
import TablePublic from '@/components/tablePublic.vue'
import Photo from '@/components/photo.vue'
import ModifcationDetail from './ModifcationDetail.vue'

import { getTrans } from '@/api/manage/shipping-order'
import { getAmdRecList } from '@/api/manage/amd-rec'

import { toUniqueStr } from '@/utils/common'
export default {
  name: 'TransportForm',
  components: {
    TablePublic,
    Photo,
    Mdialog,
    ModifcationDetail,
  },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
    type: {
      type: String,
    },
  },
  data() {
    const _this = this
    return {
      fileDialog: false,
      freshModifcationDialog: false,

      importHeaders: '',
      uploadPath: '',
      pickColLists: [
        {
          prop: 'pickingBatchBizNo',
          label: '采摘批次',
          isTrue: true,
        },
        {
          prop: 'itemFreightAmount',
          label: '运输费用（元）',
          isTrue: true,
          formatter(row) {
            return _this.ThousandAndDecimal(row.itemFreightAmount)
          },
        },
        {
          prop: 'pickingDateTime',
          label: '采摘日期',
          isTrue: true,
          formatter(row) {
            return row.pickingDateTime ? _this.parseTime(row.pickingDateTime, '{y}-{m}-{d}') : ''
          },
        },
        {
          prop: 'plantationName',
          label: '果园名称',
          isTrue: true,
        },
        {
          prop: 'locDetails',
          label: '果园区域',
          isTrue: true,
          formatter(row) {
            return row.locDetails?.split(',').slice(3).join('')
          },
        },
        {
          prop: 'geoPosDetails',
          label: '加工厂地址',
          isTrue: true,
          formatter(row) {
            return toUniqueStr(row.geoPosDetails, '北京市|天津市|上海市|重庆市')
          },
        },
        {
          prop: 'spec',
          label: '规格',
          isTrue: true,
        },
        {
          prop: 'plannedNetWeightPerUnit',
          label: '单筐净重（斤）',
          isTrue: true,
        },
        {
          prop: 'totalQuantity',
          label: '满筐总筐数',
          isTrue: true,
        },
        {
          prop: 'tailContainerWeight',
          label: '尾筐净重（斤）',
          isTrue: true,
        },
        {
          prop: 'totalNetWeight',
          label: '总净重（斤）',
          isTrue: true,
        },
      ],

      historyColLists: [
        {
          prop: 'modificationDesc',
          label: '修改内容',
          isTrue: true,
          formSolt: true,
        },
        {
          prop: 'reason',
          label: '修改原因',
          isTrue: true,
          formSolt: true,
        },
        {
          prop: 'createTime',
          label: '修改日期',
          isTrue: true,
          width: 150,
          formatter(row) {
            return row.createTime ? _this.parseTime(row.createTime, '{y}-{m}-{d}') : ''
          },
        },
        {
          prop: 'createBy',
          label: '修改人',
          isTrue: true,
          width: 150,
        },
      ],

      formData: { attachments: [], itemList: [] },
      tableData: [],

      imgArr: [],
      videoArr: [],

      historyForm: {},
    }
  },
  watch: {
    data: {
      handler(form) {
        if (!form) return

        this.getDetail(form.id)
        this.getHistoryList(form.id)
      },
      immediate: true,
    },
  },
  mounted() {},
  methods: {
    async getDetail(id) {
      const data = await getTrans(id)
      if (!data.flag || data.code !== 200) return

      this.formData = data.data

      this.imgArr = data.data.attachmentList?.filter((item) => item.type == 2).map((item) => item.url) || []
      this.videoArr =
        data.data.attachmentList?.filter((item) => item.type == 3).map((item) => ({ fileUrl: item.url })) || []
    },
    async getHistoryList(formId) {
      const data = await getAmdRecList({ formId, formType: 'shipping_order' })
      if (data.code == 200 && data.flag) {
        this.tableData = data.data
      }
    },
    handleHistoryDetail(data) {
      this.historyForm = {
        currContent: JSON.parse(data.currContent || "{}").itemList || [],
        orignalContent: JSON.parse(data.orignalContent || "{}").itemList || [],
      }
      this.freshModifcationDialog = true
    },
    lookFile() {
      this.fileDialog = true
    },
    beforeAvatarUpload() {},
    handleAvatarError() {},
    handlePropress() {},
    handleAvatarSuccess() {},
    handleDel() {},
    handleDelFile() {},
  },
}
</script>

<style scoped lang="less">
@import '../../../../assets/form.less';
::v-deep {
  .no-contract-type {
    padding: 30px;
    background-color: #f8f8f8;
    border-radius: 12px;
    text-align: center;
    border: 1px solid #dde4ff;
    margin-bottom: 20px;
  }

  .el-form-item {
    margin-bottom: 0;
  }
  .el-form-item__label {
    color: #000;
  }
}
.hbwtween {
  display: flex;
  justify-content: space-between;
}
.gap {
  margin-bottom: 30px;
}

.file {
  display: inline-block;
  cursor: pointer;
  &-icon {
    width: 100px;
    height: 100px;
  }
  &-name {
    font-size: 16px;
    text-align: center;
  }
}
</style>
